import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-pick-job-grps',
  templateUrl: './pick-job-grps.component.html',
  styleUrls: ['./pick-job-grps.component.css']
})
export class PickJobGrpsComponent implements OnInit {
    stockPlaceId;

    public setting?: Setting;

    public itemsListPickJobGroups: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.stockPlaceId = this.stateService.getStateParams()['stockplace_id'];
    }

    private async loadSetting() {
        if (!!this.stockPlaceId) {
            this.setting = (await this.datatask.Post(2164, { stockplace_id: this.stockPlaceId }))[0];
        }
    }

    private async loadPickJobGroups(): Promise<void> {
        if (this.setting?.stockplace_id) {
            this.itemsListPickJobGroups = await this.datatask.Post(2165, { stockplace_id: this.setting?.stockplace_id });
        }
    }

    public goToFunc(state: any) {
        switch (state) {
            case 'pickjobgrp':
                this.stateService?.go('pickjobgrp', {
                    stockplace_id: this.setting?.stockplace_id,
                    pickjobgrp_keyno: '0'
                });
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadPickJobGroups();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    stockplace_id: number;
    stockplace_name: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('pickJobGrps', {
//        templateUrl: 'views/components/views/pickJobGrps/pickJobGrps.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'pickJobGrpsService', function ($stateParams, stateService, utilityService, pickJobGrpsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let stockPlaceId = $stateParams.stockplace_id;

//            vm.model = {
//                setting: {},
//                itemsListPickJobGroups: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await pickJobGrpsService.getSetting({ stockplace_id: stockPlaceId }))[0];

//                loadPickJobGroups();
//            }

//            async function loadPickJobGroups() {
//                if (utilityService.validateParmsValue(vm.model.setting.stockplace_id) !== true) return;

//                vm.model.itemsListPickJobGroups = (await pickJobGrpsService.listPickJobGroups({ stockplace_id: vm.model.setting.stockplace_id }));
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'pickjobgrp':
//                        go({
//                            stockplace_id: vm.model.setting.stockplace_id,
//                            pickjobgrp_keyno: '0'
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadSetting();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
